import { type IHomeState } from './type'

export const initialState: IHomeState = {
  loading: false,
  payload: {
    cardSerialNumber: '',
    nino: '',
    schemeName: 'CSR',
    schemeIdentifier: '3W0',
    latitude: 0,
    longitude: 0,
    surName: '',
    captchaToken: '',
    scanType: 3,
  },
  expiredOrCancelledCards: [],
  activeCards: [],
  cardsResponseData: {
    cards: [],
    scheme: {
      schemeIdentifier: '',
      schemeName: '',
    },
  },
  error: '',
  captchaToken: null,
  captchaModalOpen: false,
}
